import { ApiShopperLandingPageLink } from '@storefronts/common-types'
import { useContext } from 'react'
import { SUBTLE_BORDER_COLOR_VAR } from '../../context/CustomizationContextProvider'
import { PageContext } from '../../context/PageContextProvider'
import { AnalyticsContext } from '../../context/analyticsContext'
import { ProductCard } from '../shared/ProductCard'

/**
 * The storefront's own grid card, so chat picks look and buy exactly like the
 * page: swatches, sale price, sold-out state, and the variant picker dialog
 * for products with options.
 */
export const BrandChatProductCard: React.FC<{
    link: ApiShopperLandingPageLink
}> = ({ link }) => {
    const { setActiveLPLink } = useContext(PageContext)
    const { Analytics } = useContext(AnalyticsContext)

    return (
        <ProductCard
            lpLink={link}
            background="#ffffff"
            border={`1px solid var(${SUBTLE_BORDER_COLOR_VAR})`}
            buttonBorderWidth="1px"
            preferAvailable={true}
            showAddToCart={true}
            showRatingCount={false}
            showLimitedTimeOffer={false}
            showSuperscriptPriceFormat={false}
            priceMarginTop={1}
            onClick={(_event, options) => {
                Analytics.TRACK_BRAND_CHAT_PRODUCT_CLICK(link, 'product_card')
                setActiveLPLink(link, options)
            }}
        />
    )
}
